/* StudioSoie · quiz « Quelle soie pour vous ? » (sections/ss-quiz.liquid). 3 questions, options pondérées (data-weights
   « profil:points,… »), profil gagnant révélé, newsletter ensuite ; résultat dans l'URL (?r=profil) pour partager ou
   revenir après l'inscription (le formulaire client redirige avec return_to). Vanilla, ES5, sans dépendance. */
(function () {
  'use strict';
  var root = document.querySelector('[data-ss-quiz]');
  if (!root) { return; }
  var qs = function (s, c) { return (c || root).querySelector(s); };
  var qsa = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };
  var questions = qsa('[data-ss-quiz-q]'), results = qsa('[data-ss-quiz-result]');
  var bar = qs('[data-ss-quiz-bar]'), stepEl = qs('[data-ss-quiz-step]'), news = qs('[data-ss-quiz-news]'), foot = qs('[data-ss-quiz-foot]');
  var tOf = root.getAttribute('data-t-of') || 'Question [n] sur [total]';
  var PROFILES = ['douceur', 'equilibre', 'excellence', 'rituel'];
  var answers = [], current = 0;

  function show(i) {
    current = i;
    questions.forEach(function (q, k) { q.hidden = k !== i; });
    results.forEach(function (r) { r.hidden = true; });
    if (news) { news.hidden = true; } if (foot) { foot.hidden = true; }
    if (bar) { bar.style.width = Math.round((i) / questions.length * 100) + '%'; }
    if (stepEl) { stepEl.textContent = tOf.replace('[n]', i + 1).replace('[total]', questions.length); stepEl.hidden = false; }
    var card = qs('[data-ss-quiz-card]'); if (card && i > 0) { card.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  }
  function parse(w) {
    var out = {}; String(w || '').split(',').forEach(function (p) { var kv = p.split(':'); var k = (kv[0] || '').trim().toLowerCase(), v = parseFloat(kv[1]); if (k && !isNaN(v)) { out[k] = (out[k] || 0) + v; } });
    return out;
  }
  function winner() {
    var score = {}; PROFILES.forEach(function (p) { score[p] = 0; });
    answers.forEach(function (w) { var m = parse(w); Object.keys(m).forEach(function (k) { if (k in score) { score[k] += m[k]; } }); });
    var best = PROFILES[0]; PROFILES.forEach(function (p) { if (score[p] > score[best]) { best = p; } });
    return best;
  }
  function reveal(profile, fromUrl) {
    questions.forEach(function (q) { q.hidden = true; });
    var found = false;
    results.forEach(function (r) { var on = r.getAttribute('data-ss-quiz-result') === profile; r.hidden = !on; if (on) { found = true; } });
    if (!found && results[0]) { results[0].hidden = false; profile = results[0].getAttribute('data-ss-quiz-result'); }
    if (bar) { bar.style.width = '100%'; }
    if (stepEl) { stepEl.hidden = true; }
    if (news) {
      news.hidden = false;
      var tags = qs('[data-ss-quiz-tags]', news), ret = qs('[data-ss-quiz-return]', news);
      if (tags) { tags.value = 'newsletter,quiz,profil-' + profile; }
      if (ret) { ret.value = ret.value.replace(/r=[^&]*$/, 'r=' + profile); }
    }
    if (foot) { foot.hidden = false; }
    try { var u = new URL(location.href); u.searchParams.set('r', profile); if (!fromUrl) { history.replaceState(null, '', u.pathname + u.search); } } catch (e) {}
    var card = qs('[data-ss-quiz-card]'); if (card && !fromUrl) { card.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  }
  root.addEventListener('click', function (e) {
    var opt = e.target.closest('[data-ss-quiz-opt]');
    if (opt) {
      e.preventDefault();
      answers[current] = opt.getAttribute('data-weights') || '';
      qsa('[data-ss-quiz-opt]', questions[current]).forEach(function (o) { o.classList.toggle('is-on', o === opt); });
      setTimeout(function () { if (current + 1 < questions.length) { show(current + 1); } else { reveal(winner(), false); } }, 180);
      return;
    }
    if (e.target.closest('[data-ss-quiz-back]')) { e.preventDefault(); if (current > 0) { show(current - 1); } return; }
    if (e.target.closest('[data-ss-quiz-restart]')) {
      e.preventDefault(); answers = []; qsa('[data-ss-quiz-opt]').forEach(function (o) { o.classList.remove('is-on'); });
      try { var u = new URL(location.href); u.searchParams.delete('r'); u.searchParams.delete('customer_posted'); history.replaceState(null, '', u.pathname + (u.search || '')); } catch (er) {}
      show(0); return;
    }
    var share = e.target.closest('[data-ss-quiz-share]');
    if (share) {
      e.preventDefault();
      var link = location.origin + location.pathname + '?r=' + (new URL(location.href).searchParams.get('r') || '');
      copy(link, share); return;
    }
    var cp = e.target.closest('[data-ss-quiz-copy]');
    if (cp) { e.preventDefault(); var code = qs('[data-ss-quiz-code] code'); copy(code ? code.textContent.trim() : '', cp); }
  });
  function copy(text, btn) {
    var done = function () { var t = btn.textContent; btn.textContent = btn.getAttribute('data-copied') || 'OK'; setTimeout(function () { btn.textContent = t; }, 1800); };
    if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(text).then(done).catch(done); }
    else { var ta = document.createElement('textarea'); ta.value = text; document.body.appendChild(ta); ta.select(); try { document.execCommand('copy'); } catch (e) {} document.body.removeChild(ta); done(); }
  }
  /* résultat déjà connu (lien partagé ou retour après inscription) */
  var r = null; try { r = new URL(location.href).searchParams.get('r'); } catch (e) {}
  if (r && PROFILES.indexOf(r) >= 0) { reveal(r, true); } else { show(0); }
})();
